<div
  class="toaster-container toaster-overlay-scope toaster-material-scope"
  [attr.aria-label]="getAriaLabel()"
  role="alert"
>
  <div class="toaster-content">
    <div class="toaster-icon">
      <i [class]="getIconClass()" aria-hidden="true"></i>
    </div>
    <div class="toaster-message">
      {{ data.message }}
    </div>
    @if (data.showCloseButton !== false) {
    <button
      class="toaster-close-btn"
      type="button"
      (click)="close()"
      aria-label="Close notification"
      title="Close"
    >
      <i
        class="cm-icons cm-icons-toaster-close"
        aria-hidden="true"
        [style.color]="getCloseIconColor()"
      ></i>
    </button>
    }
  </div>
</div>
